export function articleDate(value) {
	const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || '')
	if (!match) return undefined
	const [, day, month, year] = match
	const iso = `${year}-${month}-${day}`
	const parsed = new Date(`${iso}T00:00:00Z`)
	return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === iso ? iso : undefined
}

export function articleDescription(blocks = []) {
	const text = blocks.map(block => block.content || '').join(' ')
		.replace(/!\[[^\]]*\]\([^)]*\)/g, '')
		.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
		.replace(/<[^>]*>/g, '')
		.replace(/[#*_`>]/g, '')
		.replace(/\s+/g, ' ').trim()
	return text.length > 160 ? `${text.slice(0, 157).replace(/\s+\S*$/, '')}…` : text
}
